function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var User = /*#__PURE__*/function () {
  /**
   * @param {string} id
   * @param {string} name
   * @param {string} avatar
   * @param {Array} roles
   */
  function User(id, name, avatar, roles) {
    _classCallCheck(this, User);

    this.id = id;
    this.name = name;
    this.avatar = avatar;
    this.roles = roles;
  }

  _createClass(User, [{
    key: "hasRole",
    value: function hasRole(roles) {
      var _this = this;

      if (typeof roles === "string") roles = roles.split(',');
      var result = false;
      roles.forEach(function (role) {
        if (_this.roles[role.trim()] === true) result = true;
      });
      return result;
    }
  }]);

  return User;
}();

export { User as default };